<template>
    <el-dialog :title="offeringBatchDow"
               :visible="dialogVisible"
               :before-close="dialogClose"
               width="52%">
        <div class="mod-rm__coursevehiclerela" >
            <el-card shadow="never"
                     class="aui-card--fill">
                <el-table :data="dataList"
                          border
                          size="mini"
                          class="jySelectionAll"
                          v-loading="dataListLoading"
                          ref="investigationTable"
                          style="width: 100%;">
                    <el-table-column v-if="false" prop="downloadId" label="文件ID" header-align="center" align="center"></el-table-column>
                    <!-- 文件名 -->
                    <el-table-column prop="downloadName" label="文件名称" header-align="center" align="center"></el-table-column>
                    <!-- 创建时间 -->
                    <el-table-column prop="createTime" label="创建时间" header-align="center" align="center"></el-table-column>
                    <!-- 状态 -->
                    <el-table-column prop="downloadState" label="状态" header-align="center" align="center"></el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="100">
                        <template slot-scope="scope">
                            <el-button v-if="checkDow(scope.row)" @click="handleClick(scope.row)" type="text" size="small">下载</el-button>
                        </template>
                    </el-table-column>
                </el-table>
<!--               <el-pagination @size-change="sizeChangeHandle"-->
<!--                              @current-change="currentChangeHandle"-->
<!--                              :current-page="page"-->
<!--                              :page-sizes="[10, 20, 50, 100]"-->
<!--                              :page-size="limit"-->
<!--                              layout="total, sizes, prev, pager, next, jumper"-->
<!--                              :total="total">-->
<!--               </el-pagination>-->
            </el-card>
        </div>
    </el-dialog>
</template>
<script>
import mixinViewModule from '@/mixins/view-module'
export default {
  props: {
    dialogVisible: Boolean,
    dialogFlag: String
  },
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/learning/offeringdow/page',
        getDataListIsPage: true
      },
      dataForm: {
        page: 1,
        limit: 10,
          downloadId:'',
      },
      downloadId:'',
      dataList: [],
      page: 1,
      limit: 10,
      total: 0,
      dataListLoading: false,
      offeringBatchDow: '',
      initQuestionnaireData: {}
    }
  },
  created () {
      console.log("打开页面")
    this.mixinViewModuleOptions.getDataListURL = '/learning/offeringdow/page'
    this.mixinViewModuleOptions.getDataListIsPage = true
    this.getDataList()
  },
  mounted () {
    console.log('打开窗体')
    this.getDataList()
  },
  methods: {
    initMethods () {
      this.dialogVisible = true
      this.offeringBatchDow = this.$t('offering.report')
      this.getDataList()
    },
    dialogClose () {
      this.$emit('offeringDowDialogClose')
    },
    // 每页数
    sizeChangeHandle (val) {
      this.limit = val
      this.page = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.page = val
      this.getDataList()
    },
    queryCourse () {
      console.log('打开窗体')
      this.page = 1
      this.getDataList()
    },
      // 下载
    handleClick (row) {
        this.$request.downloadITM(
            '/learning/offeringdow/export',
            '结果报告',
            { downloadId: row.downloadId}
        )
    },
      // 是否显示下载按钮
    checkDow(row){
        if(row.downloadState === '上传失败'){
          return true;
        }else if(row.downloadState === '上传成功'){
          return true;
        }else {
          return false;
        }
    }
  }
}
</script>
<style lang="scss">
    /* 隐藏网格的全选按钮 */
    .jySelectionAll
    > .el-table__header-wrapper
    > .el-table__header
    > thead
    > tr
    > th
    > .cell
    > label {
        display: none !important;
    }
</style>
